module.exports = __webpack_public_path__ + "img/next-era-logo.ffc03e53.png";